import { Component, OnInit } from '@angular/core';
import { Actions } from '../../models/actions';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
})
export class NotificationDialogComponent implements OnInit {
  action = Actions;
  constructor() {}

  ngOnInit(): void {}
}
